<template>
    <div class="container-fluid stdenis-contact">
        <div class="row">
            <div class="container">
                <form role="form" @submit.prevent="submitContact">
                    <div class="col-12 contact-container">
                        <div class="contact-box">
                            <header class="stdenis-header pd-t-30">
                                <h2>Contact Us</h2>
                                <p>
                                    You can reach us via any of the means below </p>
                            </header>
                            <div class="row">
                                <div class="col-lg-5 col-md-12 c c-right">
                                    <div class="col-12">
                                        <input type="text" class="form-control" placeholder="Name" required>
                                    </div>
                                    <div class="col-12">
                                        <input type="email" class="form-control" placeholder="Email" required>
                                    </div>
                                    <div class="col-12">
                                        <input type="text" class="form-control" placeholder="Subject" required>
                                    </div>
                                    <div class="col-12">
                                        <textarea class="form-control" placeholder="Message" rows="5"
                                                  required></textarea>
                                    </div>
                                    <div class="col-12">
                                        <button class="btn stdenis-btn" type="submit">Submit&nbsp;<i
                                                class="icon ion-md-arrow-forward"></i></button>
                                    </div>

                                </div>
                                <div class="col-lg-7 col-md-12 c c-left">
                                    <div class="row">
                                        <div class="col-lg-4 col-md-12 sect">
                                            <span>
                                                <i class="icon ion-md-pin"></i>
                                            </span>
                                            <h3>Address</h3>
                                            <address>
                                                3/13, Thomas Drive,
                                                Akoka, Bariga, Lagos
                                                Nigeria
                                            </address>
                                        </div>
                                        <div class="col-lg-4 col-md-12 sect">
                                            <span>
                                                <i class="icon ion-md-call"></i>
                                            </span>
                                            <h3>Phone number</h3>
                                            <a href="tel:+23498768908">
                                                +2348165214047
                                            </a>
                                        </div>
                                        <div class="col-lg-4 col-md-12 sect">
                                            <span>
                                                <i class="icon ion-md-mail"></i>
                                            </span>
                                            <h3>Email</h3>
                                            <a href="mailto:sample@mail.com">
                                                admin@stdenisakoka.org
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2/dist/sweetalert2.js'

    export default {
        name: "contact",
        data() {
            return {}
        },
        methods: {
            submitContact() {
                Swal.fire('Submitted', 'Your request has been submitted', 'success')
            }
        },
        mounted() {
            window.scrollTo(0, 0);
        }
    }
</script>

<style scoped>
    .stdenis-contact {
        /*background: #57c2fa ;*/
        /*background-image: linear-gradient(to left, #439EF3, #57c2fa);*/
        font-family: 'Montserrat', sans-serif;
    }

    @media screen and (min-width: 320px) {
        .contact-container {
            padding: 50px 0;
            background-color: rgb(250, 250, 250);
            /*border: 1px solid rgba(0,0,0,.5);*/
            border-radius: 10px;
            margin: 20px 0;
            margin-top: 5%
        }

        .contact-box .c {
            padding: 0;
        }

        .contact-box .c div {
            margin-bottom: 20px;
        }

        .contact-box .c input, .contact-box .c textarea {
            font-weight: bold;
            resize: none;
            background-color: #e6e6e6;
            border-radius: 25px;
            border: 0;
            padding: 20px 20px 20px 30px;
            line-height: 1.5;
        }

        .contact-box .c.c-right {
            padding: 0 20px;
        }

        .contact-box .c.c-right h3 {
            text-align: center;
            margin-bottom: 20px;
        }

        .contact-box .c.c-left .sect {
            padding: 20px 0;
            margin-bottom: 20px;
        }

        .contact-box .c.c-left .sect:not(:last-of-type) {
            border-right: 1px solid #ddd;
        }

        .contact-box .c.c-left .sect span {
            display: block;
            font-size: 32px;
            margin-bottom: 10px;
        }

        .contact-box .c.c-left .sect span i {
            color: #E12993 !important;
        }

        .contact-box .c.c-left .sect h3 {
            font-size: 18px;
            margin-bottom: 15px;
            font-weight: bold;
            text-transform: uppercase;
            text-align: center;
            color: #999;
        }

        .contact-box .c.c-left .sect address {
            margin-bottom: 0;
            /*color: #000;*/
        }

        button.stdenis-btn, button.stdenis-btn i {
            color: #fff;
        }
    }

    @media screen and (min-width: 1024px) {
        .contact-box .c {
            padding: 0 70px;
        }

        .contact-box .c.c-right {
            padding: 0 40px;
        }
    }
</style>